export class Const {
  static CHUNK_HIGHLIGHT_START = '[[['
  static CHUNK_HIGHLIGHT_END = ']]]';
}